import { gql } from "@apollo/client";

const GET_RECIPIENT_APPROVAL_PREVIEW = gql`
  query getRecipientApprovalPreview($message: String!) {
    email {
      recipientApprovalPreview(message: $message) {
        htmlContent
      }
    }
  }
`;

export default GET_RECIPIENT_APPROVAL_PREVIEW;
